import auth from './auth';
import backoffice from './backoffice';
// Rexport all API services in one single object to be passed to extra thunk argument
const ApiServices = {
  auth,
  backoffice,
};

export default ApiServices;
